import React from "react";
import style from "./UserReviewCard.module.css";

import { Link } from "react-router-dom";

import Icon from "@/ui/icon/Icon";

import { timeAgo } from "@/utils/helpers";

function UserReviewCard({ review, user }) {
	const { content, stars, course, timestamp } = review;

	return (
		<div className={style.review}>
			<div className={style.course}>
				<Link
					to={`/courses/${course.slug}`}
					className={style.thumbnail}
				>
					<img src={course?.thumbnail} />
				</Link>
				<div className={style.info}>
					<Link
						to={`/courses/${course.slug}`}
						className={style.title}
					>
						{course?.name}
					</Link>
					<div className={style.lecturers}>
						{course?.lecturers.map((lecturer, index) => (
							<span key={index}>
								{lecturer?.name}
								{index < course.lecturers.length - 1
									? ", "
									: ""}
							</span>
						))}
					</div>
				</div>
			</div>
			<div className={style.text}>{content}</div>
			<div className={style.footer}>
				<div className={style.user}>
					<div className={style.imgHolder}>
						<img src={user?.safe_picture_url} />
					</div>
					<div className={style.info}>
						<div className={style.username}>{user?.username}</div>
						<div className={style.date}>
							{timeAgo(new Date(timestamp).getTime())}
						</div>
					</div>
				</div>
				<div className={style.stars}>
					{[...Array(5)].map((_, i) =>
						i < stars ? (
							<Icon icon="fa-star" key={i} />
						) : (
							<span className={style.opacity} key={i}>
								<Icon icon="fa-star" />
							</span>
						)
					)}
				</div>
			</div>
		</div>
	);
}

export default UserReviewCard;
